<template>
    <div class="voucher">
        <el-tabs v-model="activeName" @tab-click="onTabsChange">
            <el-tab-pane label="未使用" name="1">
                <table>
                    <tr class="th">
                        <td>名称</td>
                        <td>抵扣金额</td>
                        <td>有效期</td>
                    </tr>
                    <tbody v-if="coupons">
                        <tr v-for="(item, index) in coupons.list" :key="index">
                            <td>{{item.couponName}}</td>
                            <td>{{item.faceValue}}</td>
                            <td>{{item.effectiveStartTime}}至{{item.effectiveEndTime}}</td>
                        </tr>
                    </tbody>
                </table>
                <div
                    v-if="!coupons || (coupons && coupons.list.length === 0)"
                    style="font-size: 14px; margin-top: 20px; text-align: center;"
                >暂无</div>
            </el-tab-pane>
            <el-tab-pane label="已使用" name="2">
                <table>
                    <tr class="th">
                        <td>名称</td>
                        <td>抵扣金额</td>
                        <td>有效期</td>
                    </tr>
                    <tbody v-if="coupons">
                        <tr v-for="(item, index) in coupons.list" :key="index">
                            <td>{{item.couponName}}</td>
                            <td>{{item.faceValue}}</td>
                            <td>{{item.effectiveStartTime}}至{{item.effectiveEndTime}}</td>
                        </tr>
                    </tbody>
                </table>
                <div
                    v-if="!coupons || (coupons && coupons.list.length === 0)"
                    style="font-size: 14px; margin-top: 20px; text-align: center;"
                >暂无</div>
            </el-tab-pane>
            <el-tab-pane label="已作废" name="3">
                <table>
                    <tr class="th">
                        <td>名称</td>
                        <td>抵扣金额</td>
                        <td>有效期</td>
                    </tr>
                    <tbody v-if="coupons">
                        <tr v-for="(item, index) in coupons.list" :key="index">
                            <td>{{item.couponName}}</td>
                            <td>{{item.faceValue}}</td>
                            <td>{{item.effectiveStartTime}}至{{item.effectiveEndTime}}</td>
                        </tr>
                    </tbody>
                </table>
                <div
                    v-if="!coupons || (coupons && coupons.list.length === 0)"
                    style="font-size: 14px; margin-top: 20px; text-align: center;"
                >暂无</div>
            </el-tab-pane>
        </el-tabs>
        <div class="pagination">
            <el-pagination
                v-if="coupons && coupons.list.length > 0"
                background
                layout="prev, pager, next,total"
                :total="coupons.count"
                :page-size="coupons.pageSize"
                :current-page="coupons.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';

export default {
    name: 'voucher',
    data() {
        return {
            coupons: null,
            activeName: '1',
            formInline: {
                orderNO: '',
                startTime: '',
                endTime: '',
            },
        };
    },
    methods: {
        onTabsChange(e) {
            this.getCoupon(e.name);
        },
        handleCurrentChange(page) {
            this.getCoupon(+this.activeName, page);
        },
        getCoupon(couponStatus, page = 1) {
            apis.getCoupon({ couponStatus, page }).then(res => {
                this.coupons = res;
            });
        },
    },
    mounted() {
        this.getCoupon(1);
    },
};
</script>

<style lang="less" scoped>
/deep/.el-tabs__active-bar {
    background-color: #3c9539;
}
/deep/.el-tabs__item.is-active,
/deep/.el-tabs__item:hover {
    color: #3c9539;
}
</style>